<div class="person-search"><PersonSearchForm v-if="!searched" @personSearch="search"></PersonSearchForm></div>